import { render, staticRenderFns } from "./chart-number.vue?vue&type=template&id=24b88b72"
import script from "./chart-number.vue?vue&type=script&setup=true&lang=ts"
export * from "./chart-number.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports